export default function Footer() {
  const socialLinks = [
    { icon: 'ri-linkedin-fill', url: '#' },
    { icon: 'ri-twitter-x-fill', url: '#' },
    { icon: 'ri-facebook-fill', url: '#' },
    { icon: 'ri-instagram-fill', url: '#' }
  ];

  const productLinks = ['Features', 'Security', 'Download', 'Documentation'];
  const companyLinks = ['About Us', 'Privacy Policy', 'Terms of Service', 'Support'];

  return (
    <footer id="contact" className="bg-[#0A0E27] pt-24 pb-16 px-32">
      <div className="max-w-7xl mx-auto">
        {/* Top Section */}
        <div className="flex gap-20 mb-16">
          {/* Left Column - Brand */}
          <div className="w-2/5">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-shield-check-fill text-3xl text-[#00D4FF]"></i>
              </div>
              <span className="text-white text-3xl font-bold tracking-tight">SUBJEKT</span>
            </div>
            <p className="text-base text-[#8B95A8] leading-relaxed max-w-sm mb-10">
              Leading provider of secure VPN solutions, dedicated to protecting your digital privacy with military-grade encryption and cutting-edge technology.
            </p>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center text-white hover:bg-[#00D4FF] hover:border-[#00D4FF] transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Right Section - Three Columns */}
          <div className="flex-1 grid grid-cols-3 gap-12">
            {/* Contact Column */}
            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-6">
                Contact
              </h4>
              <div className="space-y-3">
                <div>
                  <p className="text-sm text-[#8B95A8] mb-1">Email:</p>
                  <p className="text-sm text-white">SUBJEKT d. o. o.</p>
                </div>
                <div>
                  <p className="text-sm text-[#8B95A8] mb-1">Phone:</p>
                  <p className="text-sm text-white">+1 8555524495</p>
                </div>
                <div>
                  <p className="text-sm text-[#8B95A8] mb-1">Address:</p>
                  <p className="text-sm text-white leading-relaxed">
                    Milutina Baraca 62<br />
                    51000 Rijeka, Croatia
                  </p>
                </div>
              </div>
            </div>

            {/* Product Column */}
            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-6">
                Product
              </h4>
              <ul className="space-y-5">
                {productLinks.map((link, index) => (
                  <li key={index}>
                    <a
                      href="#"
                      className="text-sm text-white/70 hover:text-white transition-colors duration-300 cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Column */}
            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-6">
                Company
              </h4>
              <ul className="space-y-5">
                {companyLinks.map((link, index) => (
                  <li key={index}>
                    <a
                      href="#"
                      className="text-sm text-white/70 hover:text-white transition-colors duration-300 cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-10 border-t border-white/10">
          <div className="flex items-center justify-between">
            <p className="text-sm text-[#6B7280]">
              © 2025 SUBJEKT d.o.o. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-[#6B7280] hover:text-[#00D4FF] transition-colors duration-300 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
